export enum GegRecommendationType {
    Info = 'INFO',
    Problem = 'PROBLEM',
    Warning = 'WARNING'
}
